import * as TypeStyle from 'typestyle';
import { TabStyles } from './TabStyles';
type NestedCSSProperties = TypeStyle.types.NestedCSSProperties;

export const focusIndicatorStyles = (color: string = TabStyles.Colors.Focus) => Object.freeze<NestedCSSProperties>({
  boxShadow: `0 0 4px 0 ${color}`,
  outline: `1px solid ${color} !important`,
  outlineOffset: -1,
  $nest: {
    '&::-moz-focus-inner': { $unique: true, border: 'none' }
  }
});

export const FocusVisibleIndicator = TypeStyle.style({
  $debugName: 'focus-visible-indicator',
  $nest: {
    '&:focus-visible': focusIndicatorStyles(),
  }
});
